import * as types from './types';
import _ from 'lodash';
import { TitleEnum } from 'Common/Constants/Enumeration/CommonEnum';

const INITIAL_STATE = {
  taxGroupSetupData: [],
  taxGroupSetupError: null,
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.TAXGROUP_SETUP_GET:
      return {
        ...state,
        taxGroupSetupData: action.payload.data.Data,
      };

    case types.TAXGROUP_SETUP_ERROR:
      const taxGroupSetupErrorResponse = action.payload.response;
      if (
        _.has(taxGroupSetupErrorResponse, 'data.Errors') &&
        taxGroupSetupErrorResponse.data.Errors.length
      ) {
        return {
          ...state,
          taxGroupSetupError: taxGroupSetupErrorResponse.data.Errors,
        };
      }

      return {
        ...state,
        taxGroupSetupError: {
          Title: TitleEnum.Error,
          Message:
            'An error occurred while fetching tax groups. Please try again',
        },
      };

    case types.TAXGROUP_SETUP_CLEAR:
      return {
        taxGroupSetupData: [],
        taxGroupSetupError: null,
        loading: false,
      };

    case types.TAXGROUP_SETUP_LOADING:
      return { ...state, loading: action.payload };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/inventory/taxgroupsetup/state/reducer.js